export default function Emissions({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM9.44619 12.3333C10.0424 12.3333 10.6017 12.1734 11.0842 11.8936L12.2778 13.1001C11.4756 13.6673 10.4993 14 9.44619 14C7.23146 14 5.35671 12.5286 4.72644 10.5H4V9.5H4.52442C4.50827 9.33555 4.5 9.16875 4.5 9C4.5 8.83125 4.50827 8.66445 4.52442 8.5H4V7.5H4.72644C5.35671 5.47145 7.23146 4 9.44619 4C10.4993 4 11.4756 4.33273 12.2778 4.89987L11.0842 6.10639C10.6017 5.82662 10.0424 5.66667 9.44619 5.66667C8.15878 5.66667 7.0437 6.41247 6.50067 7.5H10V8.5H6.18558C6.16131 8.6631 6.14873 8.83006 6.14873 9C6.14873 9.16994 6.16131 9.3369 6.18558 9.5H10V10.5H6.50067C7.0437 11.5875 8.15878 12.3333 9.44619 12.3333Z"
        fill="currentColor"
      />
    </svg>
  )
}
